import Vue from 'vue'
import App from '@/App.vue'
import { sync } from 'vuex-router-sync'
import store from '@/store/index.js'
import router from '@/router'
import _ from 'lodash'
import Meta from 'vue-meta'

import VueCountdownTimer from 'vuejs-countdown-timer'

import * as VueGoogleMaps from 'vue2-google-maps'
import GmapCluster from 'vue2-google-maps/src/components/cluster'

import { Loading, MessageBox, Message, Table, TableColumn, Select, Option, Tooltip, Dropdown, DropdownItem, DropdownMenu, Timeline, TimelineItem, Pagination, Divider, Drawer, Dialog, Radio, RadioGroup, Button } from 'element-ui'
import '@/assets/element-owlsight/theme/index.css'
import 'element-ui/lib/theme-chalk/drawer.css'

// Plugin
import VueLS from 'vue-ls'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-tw'
import 'dayjs/locale/th'
import 'dayjs/locale/ja'
import isBetween from 'dayjs/plugin/isBetween'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import localizedFormat from 'dayjs/plugin/localizedFormat'

import i18n from '@/i18n'

import multiSelect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

import VCalendar from 'v-calendar'

import VueNumericInput from 'vue-numeric-input'
import vueLazyLoad from 'vue-lazyload'

import { io } from 'socket.io-client'
import VueSocketIO from 'vue-socket.io'

import vClickOutside from 'v-click-outside'
import vOutsideEvents from 'vue-outside-events'

// import clickOutside from '@/directives/clickOutside'
import numeral from 'numeral'
import tippy from 'tippy.js'
import 'tippy.js/index.css'

import VueScrollactive from 'vue-scrollactive'

import SimpleVueValidator from 'simple-vue-validator'

import VModal from 'vue-js-modal'

import Cleave from 'vue-cleave-component'

import VueDragscroll from 'vue-dragscroll'

// import VueMatomo from 'vue-matomo'

// import VueAnalytics from 'vue-analytics'
import VueGtm from 'vue-gtm'

import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import { Integrations } from '@sentry/tracing'

// Vue Awesomw Swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

// UiKit
import owlsight from 'owlsight/src/tailwind.js'
import 'owlsight/dist/main.css'
import '@/stylesheets/tailwind.css'
import 'owlsight/icons/css/owl.css'
import 'owlsight/icons/css/animation.css'

import owlCookie from 'owlCookie' // owlCookie JS
import 'owlCookie/dist/owlCookie.css' // owlCookie CSS

import VueAgile from 'vue-agile'
import 'vue-agile/dist/VueAgile.css'

// App Stylesheets
import '@/stylesheets/main.sass'

import '@/utils/filters'

import vSidebar from '@/plugins/sidebar'
import vMobileMenu from '@/plugins/mobileMenu'
import ratingStars from '@/plugins/ratingStars'
import premiumImage from '@/plugins/premiumImage'

import SocialSharing from 'vue-social-sharing'

import VueFacebookPixel from 'vue-analytics-facebook-pixel'

import megaMenu from '@/plugins/megaMenu'

import searchDatePicker from '@/plugins/search/searchDatePicker'
import searchPeoplePicker from '@/plugins/search/searchPeoplePicker'
import searchPlaceInput from '@/plugins/search/searchPlaceInput'
import searchCount from '@/plugins/search/searchCount'
import searchMobileModal from '@/plugins/search/searchMobileModal'

import { VueReCaptcha } from 'vue-recaptcha-v3'

// import pangu from 'pangu'

Vue.use(megaMenu)
Vue.use(searchDatePicker)
Vue.use(searchPeoplePicker)
Vue.use(searchPlaceInput)
Vue.use(searchCount)
Vue.use(searchMobileModal)

// 填補 Array直到某個長度
_.mixin({
  complete: function (arr, val, length) {
    const l = length - arr.length
    return (l > 0) ? arr.concat(_.fill(new Array(l), val)) : arr
  }
})

Vue.use(VueCountdownTimer)

Vue.use(VueFacebookPixel)

Vue.use(ratingStars)

Vue.use(VueAgile)
Vue.use(SocialSharing)
Vue.use(vSidebar)
Vue.use(vMobileMenu)
Vue.use(premiumImage)

Vue.use(VueDragscroll)

Vue.use(VueScrollactive)

Vue.component('GmapCluster', GmapCluster)
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAP_KEY,
    libraries: 'places, drawing, visualization',
    language: store.getters['user/selectedLang'],
    loading: 'async'
    // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
  },
  // If you intend to programmatically custom event listener code
  // (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  // instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  // you might need to turn this on.
  // autobindAllEvents: false,

  // If you want to manually install components, e.g.
  // import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  // Vue.component('GmapMarker', GmapMarker)
  // then disable the following:
  installComponents: true
})

Vue.config.productionTip = false
Message.install = function (Vue, options) {
  Vue.prototype.$message = Message
}
MessageBox.install = function (Vue, options) {
  Vue.prototype.$msgbox = MessageBox
  Vue.prototype.$alert = MessageBox.alert
  Vue.prototype.$confirm = MessageBox.confirm
  Vue.prototype.$prompt = MessageBox.prompt
}
Vue.use(Loading)
Vue.use(Message)
Vue.use(MessageBox)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Select)
Vue.use(Option)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Drawer)
Vue.use(Dialog)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Tooltip)
Vue.use(Pagination)
Vue.use(Divider)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Button)

dayjs.extend(isBetween)
dayjs.extend(isSameOrAfter)
dayjs.extend(customParseFormat)
dayjs.extend(localizedFormat)

Object.defineProperty(Vue.prototype, '$dayjs', { value: dayjs })
Object.defineProperty(Vue.prototype, '$numeral', { value: numeral })
Object.defineProperty(Vue.prototype, '$tippy', { value: tippy })

Vue.component('multiSelect', multiSelect)
Vue.use(vClickOutside)
Vue.use(vOutsideEvents)
// Vue.directive('clickOutside', clickOutside)

Vue.use(VCalendar, {
  firstDayOfWeek: 2,
  screens: {
    'sm': owlsight.screens.sm,
    'md': owlsight.screens.md,
    'lg': owlsight.screens.lg,
    'xl': owlsight.screens.xl
  }
})

Vue.use(VueNumericInput)
Vue.use(vueLazyLoad, {
  // loading: 'https://loading.io/spinners/lava-lamp/index.lava-lamp-preloader.svg',
  // loading: require('@/assets/loadingSVG.svg'),
  lazyComponent: true,
  observer: true,
  observerOptions: {
    rootMargin: '0px',
    threshold: 0.1
  }
})
Vue.use(owlCookie, {
  keyName: 'OwlJourney'
})
Vue.use(Meta)

Vue.use(VueLS, {
  namespace: `owljourney_${process.env.NODE_ENV}_`, // key prefix
  name: 'ls', // name variable Vue.[ls] or this.[$ls],
  storage: 'local', // storage name session, local, memory
})

SimpleVueValidator.extendTemplates({
  error: i18n.t('validatorErrors.error'),
  required: i18n.t('required'),
  float: i18n.t('validatorErrors.float'),
  integer: i18n.t('validatorErrors.integer'),
  number: i18n.t('validatorErrors.number'),
  lessThan: i18n.t('validatorErrors.lessThan'),
  lessThanOrEqualTo: i18n.t('validatorErrors.lessThanOrEqualTo'),
  greaterThan: i18n.t('validatorErrors.greaterThan'),
  greaterThanOrEqualTo: i18n.t('validatorErrors.greaterThanOrEqualTo'),
  between: i18n.t('validatorErrors.between'),
  size: i18n.t('validatorErrors.size'),
  length: i18n.t('validatorErrors.length'),
  minLength: i18n.t('validatorErrors.minLength'),
  maxLength: i18n.t('validatorErrors.maxLength'),
  lengthBetween: i18n.t('validatorErrors.lengthBetween'),
  in: i18n.t('validatorErrors.in'),
  notIn: i18n.t('validatorErrors.notIn'),
  match: i18n.t('validatorErrors.match'),
  regex: i18n.t('validatorErrors.regex'),
  digit: i18n.t('validatorErrors.digit'),
  email: i18n.t('validatorErrors.email'),
  url: i18n.t('validatorErrors.url')
  // optionCombiner: function (options) {
  //   if (options.length > 2) {
  //     options = [options.slice(0, options.length - 1).join('，'), options[options.length - 1]]
  //   }
  //   return options.join(' 或 ')
  // }
})
Vue.use(SimpleVueValidator)
// SimpleVueValidator.setMode('conservative')

Vue.use(VModal, {
  dialog: true,
  dynamic: true,
  injectModalsContainer: true
})

Vue.use(Cleave)

// Home components
const requireComponent = require.context(
  // The relative path of the components folder
  '@/modules',
  // Whether or not to look in subfolders
  false,
  // The regular expression used to match base component filenames
  /.(vue|js)$/
)
requireComponent.keys().forEach(fileName => {
  // Get component config
  // const componentConfig = requireComponent(fileName)
  // console.debug('Loaded Home Components', componentConfig.default.name, componentConfig)
  // Get PascalCase name of component
  const componentName = _.upperFirst(
    _.camelCase(
      // Gets the file name regardless of folder depth
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
    )
  )

  // Register component globally
  Vue.component(
    componentName,
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    // componentConfig.default || componentConfig,
    () => import('@/modules/' + componentName.charAt(0).toLowerCase() + componentName.slice(1) + '.vue')
  )
})

sync(store, router)

// Vue.use(VueMatomo, {
//   host: 'https://matomo.owlting.com',
//   siteId: 4,
//   router: router,
//   debug: process.env.NODE_ENV !== 'production'
// })

Vue.use(VueGtm, {
  id: process.env.VUE_APP_GTM_KEY,
  // queryParams: {
  //   gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
  //   gtm_preview: 'env-4',
  //   gtm_cookies_win: 'x'
  // },
  enabled: true,
  debug: process.env.NODE_ENV !== 'production',
  loadScript: true,
  vueRouter: router,
  ignoredViews: ['ApplePay', 'Callback', 'Auth']
})

// pangu.autoSpacingPage()

Sentry.init({
  dsn: 'https://bc14d5db0b934ce2aceaf75db775c3a6@sentry.owlting.com/2',
  environment: process.env.NODE_ENV,
  integrations: [
    new VueIntegration({
      Vue,
      tracing: true
    }),
    new Integrations.BrowserTracing()
  ],

  tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0
})

const socketOptions = {
  autoConnect: false,
  reconnection: true,
  reconnectionDelay: 10,
  reconnectionAttempts: 10,
  transports: ['websocket'],
  auth: {
    Authorization: process.env.VUE_APP_SOCKET_API_KEY
  }
}
const socket = io(process.env.VUE_APP_SOCKET_URL, socketOptions)

socket.on('reconnect_attempt', () => {
  socket.io.opts.transports = ['polling', 'websocket']
})

Vue.use(
  new VueSocketIO({
    // debug: process.env.NODE_ENV === 'development',
    debug: false,
    connection: socket
  })
)

Vue.use(VueAwesomeSwiper)

// 註冊 VueReCaptcha
Vue.use(VueReCaptcha, {
  siteKey: '6Ldk8QgsAAAAAF0gFSjtT5BtA2lVaZHpUTpJZcNr', // 替換成你的 site key
  loaderOptions: {
    useRecaptchaNet: true, // 可選，默認 false
    autoHideBadge: true // 自動隱藏右下角徽章
  }
})

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
